import styled from '@emotion/styled';
import { Iframe } from 'src/domains/layouts/webview/components/Iframe';
import { withConfig } from 'src/withConfig';
import { headerHeight } from 'src/domains/layouts/ui/ui.style';

export const ModalWrapper = withConfig(theme => styled('div', { label: 'ModalWrapper' })<{bannersHeight: number, isAccountsOpened: boolean}>`
    height: 100%;
    position: fixed;
    width: 100%;
    z-index: ${({ isAccountsOpened }): number => isAccountsOpened ? theme.star.zIndexGlobal.below + theme.star.zIndexGlobal.rhsMenu : theme.star.zIndexGlobal.highLevel};
    padding-bottom: ${({ bannersHeight }): string => `${bannersHeight + headerHeight}px`};
`);

export const IframeContainer = styled('div', { label: 'IframeContainer' })`
    height: 100%;
    position: relative;
    width: 100%;
`;

export const BetGliderIframe = styled(Iframe, { label: 'BetGliderIframe' })`
    border: 0;
    height: 100%;
    width: 100%;
`;
